var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nz-dialog',{ref:"dialog",attrs:{"customClass":"preview-image-dialog"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":_vm.src}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53019672","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/preview-image-dialog.vue
// module id = null
// module chunks = 